import { UpdateSenha } from "../../../models/modules/Cliente/Senha";
import { apiTravel } from "../travel";

export function postTokenEmail(codigoCliente: string): Promise<any>{
    return apiTravel.post(`/cliente/email-senha/${codigoCliente}`);
  }

  export function putTokenSenha(body: UpdateSenha): Promise<any>{
    return apiTravel.put(`/cliente/atualiza-senha/`, body);
  }